import { useEffect, useRef } from 'react';
import { useRouterState } from '@tanstack/react-router';

/**
 * Popover (menu, ajustes) fecha quando a tela muda. Sem isto ele ficaria
 * aberto por cima da tela nova enquanto o AnunciadorDeRota move o foco.
 */
export function useFecharAoNavegar<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const caminho = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => {
    const el = ref.current;
    try {
      if (el?.matches(':popover-open')) el.hidePopover();
    } catch {
      // Navegador sem popover: o elemento já está sempre visível no fluxo.
    }
  }, [caminho]);
  return ref;
}
